import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-appointment-list-section',
  templateUrl: './appointment-list-section.component.html',
  styleUrls: ['./appointment-list-section.component.scss']
})
export class AppointmentListSectionComponent
{
  @Input() public memberId: number;
  @Output() public refresh: EventEmitter<any> = new EventEmitter();

  public onRefresh(): void
  {
    this.refresh.emit();
  }
}
